<div class='info'>
</div>

<svg class="graph">
    <g class="inner"></g>
</svg>